import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { TabularReportComponent } from './tabular-report.component';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { LegfiDatePipeModule } from 'app/pipes/format/legfi-date.module';
import { LengthAwarePaginatorModule } from '../pagination/length-aware-paginator/length-aware-paginator.module';
import { LegfiCurrencyPipeModule } from 'app/pipes/format/legfi-currency.module';
import { NewlineToBreakPipeModule } from 'app/pipes/format/nl2br.module';

@NgModule({
    imports: [
        SharedModule,
        MatPaginatorModule,
        MatTableModule,
        MatSortModule,
        LegfiDatePipeModule,
        LegfiCurrencyPipeModule,
        NewlineToBreakPipeModule,
        MatIconModule,
        LengthAwarePaginatorModule,
    ],
    exports: [TabularReportComponent],
    declarations: [TabularReportComponent],
})
export class TabularReportModule
{
}
